export default __webpack_public_path__ + "static/media/money-liquidity.6e0dafe2.svg";